import Box from "@material-ui/core/esm/Box";
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import React from 'react';
import { SecondaryButton } from 'components/Button';
import useStyles from './ButtonStyles';
export default function AddAddressButton({
  onClick,
  children
}) {
  const {
    addAddress
  } = useStyles();
  return /*#__PURE__*/React.createElement(SecondaryButton, {
    className: addAddress,
    onClick: onClick,
    startIcon: /*#__PURE__*/React.createElement(ControlPointIcon, null)
  }, /*#__PURE__*/React.createElement(Box, {
    ml: 1
  }, children));
}